import React from 'react';

interface LocationInfoProps {
  userLocation: [number, number] | null;
  locationAddress?: string;
  translations?: Record<string, string>;
}

/**
 * Displays current user location and address
 * Should be placed in the left panel of pages
 */
const LocationInfo: React.FC<LocationInfoProps> = ({ userLocation, locationAddress, translations = {} }) => {
  return (
    <>
      <div className="location-info">
        {userLocation ? (
          <p>
            📍 {translations["place.currentLocation"]}: {userLocation[0].toFixed(4)}, {userLocation[1].toFixed(4)}
          </p>
        ) : (
          <p>📍 {translations["place.gettingLocation"]}</p>
        )}
      </div>

      {locationAddress && (
        <div className="location-address">
          <p>{locationAddress}</p>
        </div>
      )}
    </>
  );
};

export default LocationInfo;